module.exports = __webpack_public_path__ + "img/base_hebergements_camping.04fd697f.svg";